import { Input } from '@chakra-ui/react'
import { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'

const AmountInput = ({ amount, min, max, onChange }: { amount: number; min: number; max: number; onChange: (amount: number) => void }) => {
    const { t } = useTranslation()
    const [value, setValue] = useState<number | undefined>(amount ?? 0)
    const [isValid, setIsValid] = useState<boolean>(true)

    useEffect(() => {
        setValue(amount || 0)
        setIsValid(value !== undefined && value >= min && value <= max)
    }, [amount, max, min, value])

    useEffect(() => {
        setIsValid(true)
    }, [])

    const saveAmount = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value
        if (inputValue) {
            setValue(Number(inputValue))
            onChange(Number(inputValue))
        } else setValue(undefined)
    }

    return (
        <Flex flexDir="column">
            <Input
                placeholder="Enter amount"
                value={value}
                onChange={saveAmount}
                variant="outline"
                fontSize="14px"
                letterSpacing="0.25px"
                type="number"
                borderColor={isValid ? 'rgba(84, 79, 64, 0.7)' : 'rgba(255, 0, 0, 0.7)'}
                outline="none"
                _focus={{
                    borderColor: isValid ? 'rgba(84, 79, 64, 0.7)' : 'rgba(255, 0, 0, 0.7)',
                    outline: 'none',
                    boxShadow: 'none',
                }}
            />
            {!isValid && (
                <Text fontSize="14px" color="var(--chakra-colors-status-error)" mt="4px">
                    {t('tasksApprovals.grpDrawer.amountInputError', { min, max })}
                </Text>
            )}
        </Flex>
    )
}

export default AmountInput
